import React from "react";

import FlatCard from "components/UI-lib/FlatCard";
import { Zap, Settings } from "lucide-react";

export type LaunchablePath = "quick-start" | "custom" | null;

interface LaunchableIntentSelectorProps {
  onSelect: (path: LaunchablePath) => void;
}

export const LaunchableIntentSelector: React.FC<
  LaunchableIntentSelectorProps
> = ({ onSelect }) => {
  return (
    <div>
      <h2 className="text-primary text-xl font-semibold mb-4">
        How would you like to create your Launchable?
      </h2>
      <p className="text-secondary mb-6">
        Choose the approach that best matches your needs and experience level.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FlatCard
          className="cursor-pointer border-2 hover:border-highlight transition-colors"
          onClick={() => onSelect("quick-start")}
        >
          <div className="pb-2">
            <h3 className="flex items-center text-primary font-semibold mb-1">
              <Zap className="mr-2 h-5 w-5 text-highlight" />
              Quick Start
            </h3>
            <p className="text-sm text-secondary">
              Simple setup with sensible defaults
            </p>
          </div>
          <p className="text-sm text-secondary">
            Get started quickly with a Launchable VM environment that includes a
            first-class Jupyter Notebook experience. Just upload your files and
            choose your compute resource. Great for quickly sharing your demo or
            tutorial with others.
          </p>
          <ul className="mt-3 text-sm text-secondary list-disc pl-5 space-y-1">
            <li>Pre-configured VM environment</li>
            <li>Jupyter pre-installed</li>
          </ul>
        </FlatCard>

        <FlatCard
          className="cursor-pointer border-2 hover:border-highlight transition-colors"
          onClick={() => onSelect("custom")}
        >
          <div className="pb-2">
            <h3 className="flex items-center text-primary font-semibold mb-1">
              <Settings className="mr-2 h-5 w-5 text-highlight" />
              Fully Customizable
            </h3>
            <p className="text-sm text-secondary">
              Complete control over your environment
            </p>
          </div>
          <p className="text-sm text-secondary">
            Build your launchable from scratch with full control over
            containers, networking, and experience. Perfect for complex setups
            and advanced users to showcase and share their workflows.
          </p>
          <ul className="mt-3 text-sm text-secondary list-disc pl-5 space-y-1">
            <li>Custom container configurations</li>
            <li>Advanced networking options</li>
            <li>Complete environment control</li>
          </ul>
        </FlatCard>
      </div>
    </div>
  );
};
